import { filterParams } from '@/common/utils/format'
import { get, pick } from 'lodash-es'
import { i18n, getBDCountry, sprintf } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'


const KEYS = ['officialUrl']

export function revert (data = {}) {
  const contractData = get(data, 'shopGlobal')
  let revertted = {}
  if (contractData) {
    revertted = pick(contractData, KEYS)
  }
  return revertted
}

export function submitFormat (shopGlobal) {
    return {
      params: JSON.stringify({
        source: 'contractor',
        queryId: this.id,
        shopGlobal
      })
    }
  }

export default {
  revert,
  submitFormat
}
